module.exports = __webpack_public_path__ + "img/sad-sloth.2995b7a3.svg";